// src/components/LanguageSwitcher/LanguageSwitcher.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './LanguageSwitcher.module.css';

const LanguageSwitcher = ({ variant = 'desktop' }) => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (language) => {
    i18n.changeLanguage(language);
    // Store language preference in localStorage
    localStorage.setItem('preferred-language', language);
  };

  const currentLanguage = i18n.language || 'en';

  if (variant === 'mobile') {
    return (
      <div className={styles.mobileLanguageSwitcher}>
        <button
          className={`${styles.mobileLanguageButton} ${currentLanguage === 'en' ? styles.active : ''}`}
          onClick={() => handleLanguageChange('en')}
        >
          English
        </button>
        <button
          className={`${styles.mobileLanguageButton} ${currentLanguage === 'ms' ? styles.active : ''}`}
          onClick={() => handleLanguageChange('ms')}
        >
          Bahasa Malaysia
        </button>
      </div>
    );
  }

  return (
    <div className={styles.languageSwitcher}>
      <button
        className={`${styles.languageButton} ${currentLanguage === 'en' ? styles.active : ''}`}
        onClick={() => handleLanguageChange('en')}
        aria-label="Switch to English"
      >
        EN
      </button>
      <div className={styles.separator}>|</div>
      <button
        className={`${styles.languageButton} ${currentLanguage === 'ms' ? styles.active : ''}`}
        onClick={() => handleLanguageChange('ms')}
        aria-label="Switch to Bahasa Malaysia"
      >
        MS
      </button>
    </div>
  );
};

export default LanguageSwitcher;